require('../../../../plugins/stimpack/src/js/main.js');
